angular
    .module("home.service")
    .service('userService', ['$filter', '$rootScope', '$q', '$timeout', 'httpService', 'browser', 'popupService',
        function ($filter, $rootScope, $q, $timeout, httpService, browser, popupService) {
            return {
                login: login,
                logout: logout,
                setUserArray: setUserArray,
                changePassword: changePassword,
                requestResetPassword: requestResetPassword,
                resetPassword: resetPassword,
                isPasswordValid: isPasswordValid,
                requestCaptchaImage: requestCaptchaImage,
                clearAuthenticatedSession: clearAuthenticatedSession,
                checkTermConditionAgree: checkTermConditionAgree
            };

            function login(credentials, isUrlVic) {
                var apiTarget = "api/users/login",
                    values = JSON.stringify({
                        Identifier: credentials.identifier,
                        Password: credentials.password,
                        DateOfBirth: credentials.dob,
                        IsUrlVic: isUrlVic,
                        IsClaimant: credentials.isClaimant
                    });

                return httpService.httpRequest(apiTarget, values, 'POST');
            }
            function clearAuthenticatedSession()
            {
                var loginAttempts = $filter('dec2num')(sessionStorage.loginAttempts) || 0;
                sessionStorage.clear();
                sessionStorage.loginAttempts = $filter('enstr64')(loginAttempts);
                setUserArray();
            }
            function logout() {
                if ($filter('dec2bool')(sessionStorage.LoggedIn)) {
                    var apiTarget = "api/users/logout",
                        values = JSON.stringify({
                            Identifier: $filter('decstr64')(sessionStorage.Identifier),
                            SessionKey: $filter('decstr64')(sessionStorage.SessionKey)
                        });
                    httpService.httpRequest(apiTarget, values, 'POST');
                }
                clearAuthenticatedSession();
                location.href = '/';

                $rootScope.$broadcast('scanner-started');
            }

            function setUserArray(delayLogginTime) {
                $rootScope.IsClaimant = $filter('decstr64')(sessionStorage.IsClaimant) === 'true';
                $rootScope.IsACT = $filter('decstr64')(sessionStorage.IsACT) === 'true';
                var isNsiUser = $filter('dec2bool')(sessionStorage.IsNsiUser);
                // update user information
                $rootScope.user = {
                    Identifier: $filter('decstr64')(sessionStorage.Identifier) || "",
                    DisplayName: $filter('decstr64')(sessionStorage.DisplayName) || "",
                    EmailAddress: $filter('decstr64')(sessionStorage.EmailAddress) || "",
                    EmailAddressTruncate: '',
                    BrokerNumber: $filter('decstr64')(sessionStorage.BrokerNumber) || "",
                    SessionKey: sessionStorage.SessionKey || "",
                    EtlTime: sessionStorage.EtlTime || "",
                    BusinessUnit: $filter('dec2arr')(sessionStorage.BusinessUnit, parseInt),
                    MultipleJurisdiction: ($filter('dec2arr')(sessionStorage.BusinessUnit, parseInt)).length > 1,
                    PolicyNumber: $filter('decstr64')(sessionStorage.PolicyNumber) || "",
                    TotalEmiusPolicy: parseInt($filter('decstr64')(sessionStorage.TotalEmiusPolicy) || 0),
                    TotalICarePolicy: parseInt($filter('decstr64')(sessionStorage.TotalIcarePolicy) || 0),
                    TotalPolicy:parseInt($filter('decstr64')(sessionStorage.TotalPolicy) || 0),
                    LstCostCentre: $filter('decstr64')(sessionStorage.LstCostCentre),
                    IsNsiUser: isNsiUser,
                    IsSuperUser: $filter('dec2bool')(sessionStorage.IsSuperUser),
                    IsEmployer: $filter('dec2bool')(sessionStorage.IsEmployer),
                    IsBroker: $filter('dec2bool')(sessionStorage.IsBroker),
                    IsNsiClaimant: isNsiUser && $rootScope.IsClaimant,
                    DateOfBirth: $filter('decstr64')(sessionStorage.DateOfBirth),
                    IsClaimant: $filter('dec2bool')(sessionStorage.IsClaimant),
                    IsAcceptTermCondition: $filter('dec2bool')(sessionStorage.IsAcceptTermCondition),
                    AllowReviewClaim: $filter('dec2bool')(sessionStorage.AllowReviewClaim),
                };

                if(delayLogginTime) {
                    $timeout(function() {
                        $rootScope.user.LoggedIn = $filter('dec2bool')(sessionStorage.LoggedIn) || false;
                    }, delayLogginTime);
                } else {
                    $rootScope.user.LoggedIn = $filter('dec2bool')(sessionStorage.LoggedIn) || false;
                }

                var isDeviceType = browser.getDeviceType();
                $rootScope.user.EmailAddressTruncate = _.trunc($rootScope.user.EmailAddress, isDeviceType ? 30 : 40);

                _.assign($rootScope.pageNavigationHistory, {
                    policy: $filter('dec2obj')(sessionStorage.Policy || null),
                    claim: $filter('dec2obj')(sessionStorage.Claim || null) 
                });
            }

            function changePassword(changePasswordModel) {
                var def = $q.defer(),
                    apiTarget = "api/credentials/changepassword",
                    values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        OldPassword: changePasswordModel.password,
                        ConfirmedPassword: changePasswordModel.repeatPassword,
                        NewPassword: changePasswordModel.newPassword
                    });
                httpService.httpRequest(apiTarget, values, null, 'POST').then(function (result) {
                    def.resolve(angular.fromJson(result));
                });
                return def.promise;
            }
            function requestResetPassword(requestResetPasswordModel) {
                var def = $q.defer(),
                    apiTarget = "api/credentials/forgotpassword",
                    values = JSON.stringify({
                        // Identifier: requestResetPasswordModel.identifier,
                        Email: requestResetPasswordModel.email,
                        //Captcha model
                        CaptchaString: requestResetPasswordModel.captchaString,
                        CaptchaStringEncrypt: requestResetPasswordModel.captchaStringEncrypt,
                        Token: requestResetPasswordModel.captchaToken
                    });
                httpService.httpRequest(apiTarget, values, 'POST').then(function (result) {
                    def.resolve(angular.fromJson(result));
                });
                return def.promise;
            }

            function resetPassword(model) {
                var def = $q.defer(),
                    apiTarget = "api/credentials/resetpassword",
                    values = JSON.stringify({
                        Identifier: model.identifier,
                        Token: model.token,
                        NewPassword: model.newPassword
                    });
                httpService.httpRequest(apiTarget, values, null, 'POST').then(function (result) {
                    def.resolve(angular.fromJson(result));
                });
                return def.promise;
            }

            function isPasswordValid(password) {
                var minLength = 8,
                    length = password !== undefined ? password.length : 0;
                return length >= minLength && /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/.test(password);
            }

            // Generate captcha image
            function requestCaptchaImage() {
                var def = $q.defer(),
                    apiTarget = "api/credentials/getcaptchastring",
                    values = JSON.stringify({});
                httpService.httpRequest(apiTarget, values).then(function (result) {
                    def.resolve(angular.fromJson(result));
                });
                return def.promise;
            }

            function checkTermConditionAgree() {
                if(!$rootScope.user.IsAcceptTermCondition) {
                    // delay to wait homepage done loading
                    $timeout(function () {
                        var otpions = {
                            showHeader: false,
                            showCloseButton: false,
                            otherTheme: false,
                            additionClass: 'term-condition-popup'
                        };
        
                        popupService.show('termCondition', 'term-condition-agreement', otpions);
                    }, 1000);
                }
            }
        }]);
